module.exports = __webpack_public_path__ + "static/img/iconmonstr-microphone-4.f654a428.svg";